export const Online = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8 14C4.686 14 2 11.314 2 8C2 4.686 4.686 2 8 2C11.314 2 14 4.686 14 8"
        class="stroke-inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.33997 6.00033H13.5866"
        class="stroke-inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.33997 9.99935H7.99997"
        class="stroke-inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.6666 7.99983C10.6666 6.15717 10.1846 4.3145 9.22195 2.7065C8.65728 1.7645 7.34262 1.7645 6.77862 2.7065C4.85195 5.92317 4.85195 10.0772 6.77862 13.2938C7.06062 13.7645 7.53062 14.0005 8.00062 14.0005"
        class="stroke-inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.78 12.7801L14.45 12.1121C14.744 11.9948 14.7374 11.5761 14.44 11.4675L10.4627 10.0215C10.188 9.92147 9.92204 10.1881 10.0214 10.4628L11.4674 14.4401C11.5754 14.7381 11.994 14.7441 12.112 14.4501L12.78 12.7801Z"
        class="stroke-inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const OnlineAndInStore = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M5.669 2.00098V3.20148C5.65235 3.40351 5.80075 3.58158 6.00247 3.60164H8.67025C8.87197 3.58158 9.02037 3.40351 9.00372 3.20148V2.00098"
        class="stroke-inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.33555 14.006H4.66861C3.93192 14.006 3.33472 13.4088 3.33472 12.6721V3.33487C3.33472 2.59818 3.93192 2.00098 4.66861 2.00098H10.0042C10.7408 2.00098 11.338 2.59818 11.338 3.33487V6.00264"
        class="stroke-inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.00327 10.7705V14.0058"
        class="stroke-inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3388 14.0058V10.7705"
        class="stroke-inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.6711 14.0058V12.6719"
        class="stroke-inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.68311 14.0063H13.6589"
        class="stroke-inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.34742 10.8324V10.8324C7.99606 10.832 7.67006 10.6493 7.4862 10.3499C7.30233 10.0505 7.2869 9.67716 7.44543 9.3636L7.88474 8.49566C8.03802 8.19394 8.34749 8.00361 8.68591 8.00293H12.6544C12.9934 8.00272 13.3038 8.19288 13.4576 8.49499L13.8969 9.36292C14.0554 9.67649 14.04 10.0498 13.8561 10.3493C13.6723 10.6487 13.3463 10.8313 12.9949 10.8317C12.4966 10.8319 12.0535 10.5145 11.8933 10.0426C11.8826 10.0184 11.8587 10.0028 11.8322 10.0028C11.8057 10.0028 11.7818 10.0184 11.7711 10.0426C11.6111 10.5144 11.1683 10.8318 10.6702 10.8318C10.172 10.8318 9.7292 10.5144 9.56921 10.0426C9.55853 10.0184 9.53457 10.0028 9.50812 10.0028C9.48166 10.0028 9.4577 10.0184 9.44703 10.0426C9.28665 10.5144 8.8437 10.8317 8.34542 10.8317"
        class="stroke-inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const InStore = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2.66663 4.66699V3.33366C2.66663 2.96547 2.9651 2.66699 3.33329 2.66699H12.6666C13.0348 2.66699 13.3333 2.96547 13.3333 3.33366V4.66699"
        class="stroke-inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.3333 4.66699H2.66667C2.29848 4.66699 2 4.96547 2 5.33366V12.667C2 13.4034 2.59695 14.0003 3.33333 14.0003H12.6667C13.403 14.0003 14 13.4034 14 12.667V5.33366C14 4.96547 13.7015 4.66699 13.3333 4.66699Z"
        class="stroke-inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.6667 7.33301C10.6667 8.80577 9.4728 9.99967 8.00004 9.99967C6.52728 9.99967 5.33337 8.80577 5.33337 7.33301"
        class="stroke-inherit"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="shrink-0"
    >
      <path
        d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="text-text-normal-secondary"
      />
      <path
        d="M21 21L16.65 16.65"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="text-text-normal-secondary"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.8037 6.13665C13.0966 5.84394 13.5714 5.84382 13.8642 6.13665C14.1565 6.42954 14.1567 6.90448 13.8642 7.1972L11.0605 9.99994L13.8642 12.8036C14.1564 13.0966 14.1568 13.5715 13.8642 13.8642C13.5716 14.1568 13.0966 14.1564 12.8037 13.8642L9.99994 11.0605L7.19721 13.8642C6.90449 14.1567 6.42955 14.1565 6.13666 13.8642C5.84382 13.5714 5.84393 13.0966 6.13666 12.8036L8.9394 9.99994L6.13666 7.1972C5.84377 6.90431 5.84377 6.42955 6.13666 6.13665C6.42956 5.84378 6.90432 5.84377 7.19721 6.13665L9.99994 8.93939L12.8037 6.13665Z"
        class="fill-text-normal-secondary"
      />
    </svg>
  );
};

export const PlusIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 4.16667V15.8333M4.16667 10H15.8333"
        stroke="currentColor"
        stroke-width="1.67"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
